import React from "react";
import { Formik, Form, Field } from "formik";
import { ApiService } from "../../../../../services/ApiService";

export default function AssigncaseModal({
  closeModal,
  employee_cases,
  alert,
  cases,
  employees,
}) {
  return (
    <React.Fragment>
      <Formik
        initialValues={{ case: "", assigned_to: "", penalty: "" }}
        onSubmit={(values) => {
          ApiService.post("disciplinary-cases/assign-case", values).then(
            (res) => {
              if (res.data.type === false) {
                alert.error(res.data.msg);
              } else if (res.data.type === true) {
                alert.success(res.data.msg);
                employee_cases();
                closeModal();
              }
            }
          );
        }}
      >
        {({ handleSubmit, values, isSubmitting }) => (
          <Form>
            <div className="form-group">
              <label>
                {" "}
                cases<span className="text-danger"> * </span>
              </label>
              <Field
                as="select"
                className="form-control"
                id="case"
                name="case"
                required
              >
                <option value="">--Select case--</option>

                {cases.map((cas, i) => (
                  // <div key={i}>
                  <option value={cas.id}>{cas.name}</option>
                  // </div>
                ))}
              </Field>
            </div>

            <div className="form-group">
              <label>
                Employees <span className="text-danger"> * </span>
              </label>
              <Field
                as="select"
                className="form-control"
                name="assigned_to"
                required
              >
                <option value="">--Select Employee--</option>

                {employees.map((employee, i) => (
                  <option value={employee.id} key={i}>
                    {employee.first_name}
                  </option>
                ))}
              </Field>
            </div>
            <div className="form-group">
              <label>
                {" "}
                Penalty 
              </label>
              <Field
                type="text"
                className="form-control"
                id="penalty"
                name="penalty"
                placeholder="Penalty"
                autoComplete="off"
               
              />
            </div>

            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-10">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Save{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/employeemanagement/disciplinarycase/modals/assign_case.js